export default __webpack_public_path__ + "static/media/wave2.47f6bdf5.svg";